import { isPlatformBrowser } from '@angular/common';
import { DestroyRef, inject, Injectable, PLATFORM_ID, signal } from '@angular/core';

/** Estado compartilhado do header que some ao scrollar — usado também pelo sticky do DataCuidados. */
@Injectable({ providedIn: 'root' })
export class HideOnScrollService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly platformId = inject(PLATFORM_ID);

  readonly hidden = signal(false);

  private lastY = 0;
  private ticking = false;
  private connected = false;

  connect(options: { threshold?: number; topOffset?: number } = {}): void {
    if (!isPlatformBrowser(this.platformId) || this.connected) {
      return;
    }
    this.connected = true;

    const threshold = options.threshold ?? 8;
    const topOffset = options.topOffset ?? 80;

    const update = () => {
      const y = window.scrollY;
      const delta = y - this.lastY;

      if (y < topOffset) {
        this.hidden.set(false);
      } else if (Math.abs(delta) > threshold) {
        this.hidden.set(delta > 0);
      }

      this.lastY = y;
      this.ticking = false;
    };

    const onScroll = () => {
      if (!this.ticking) {
        window.requestAnimationFrame(update);
        this.ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    this.destroyRef.onDestroy(() => {
      window.removeEventListener('scroll', onScroll);
      this.connected = false;
    });
  }
}
